// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modern-table-container {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  max-height: 60vh;
  overflow: auto;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  background: #ffffff;
  border: 1px solid #edf2f7;
  margin-top: 1vh;
}
.modern-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: 'Inter', sans-serif;
  font-size: 1.5vh;
}
.modern-table thead th {
  position: sticky;
  top: 0;
  background: rgba(247, 250, 252, 0.95);
  backdrop-filter: blur(4px);
  color: #4a5568;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 1.8vh 2vh;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
  z-index: 10;
  white-space: nowrap;
}
.modern-table tbody tr {
  transition: background-color 0.2s ease;
}
.modern-table tbody tr:hover {
  background-color: #f8fafc;
}
.modern-table tbody td {
  padding: 1.5vh 2vh;
  color: #2d3748;
  border-bottom: 1px solid #edf2f7;
  vertical-align: middle;
}
.modern-table tbody tr:last-child td {
  border-bottom: none;
}
.status-badge {
  padding: 0.6vh 1.5vh;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1.3vh;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.status-aprobado {
  background-color: #def7ec;
  color: #03543f;
  border: 1px solid #c8ebdf;
}
.status-rechazado {
  background-color: #fde8e8;
  color: #9b1c1c;
  border: 1px solid #fbd5d5;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modernTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,qCAAqC;EACrC,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".modern-table-container {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  max-height: 60vh;\n  overflow: auto;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n  background: #ffffff;\n  border: 1px solid #edf2f7;\n  margin-top: 1vh;\n}\n.modern-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-family: 'Inter', sans-serif;\n  font-size: 1.5vh;\n}\n.modern-table thead th {\n  position: sticky;\n  top: 0;\n  background: rgba(247, 250, 252, 0.95);\n  backdrop-filter: blur(4px);\n  color: #4a5568;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 1.8vh 2vh;\n  text-align: left;\n  border-bottom: 2px solid #e2e8f0;\n  z-index: 10;\n  white-space: nowrap;\n}\n.modern-table tbody tr {\n  transition: background-color 0.2s ease;\n}\n.modern-table tbody tr:hover {\n  background-color: #f8fafc;\n}\n.modern-table tbody td {\n  padding: 1.5vh 2vh;\n  color: #2d3748;\n  border-bottom: 1px solid #edf2f7;\n  vertical-align: middle;\n}\n.modern-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.status-badge {\n  padding: 0.6vh 1.5vh;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 1.3vh;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.status-aprobado {\n  background-color: #def7ec;\n  color: #03543f;\n  border: 1px solid #c8ebdf;\n}\n.status-rechazado {\n  background-color: #fde8e8;\n  color: #9b1c1c;\n  border: 1px solid #fbd5d5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
